export const baseUrl = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/api/v1`;
export const baseUrl_V2 = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/api/v2`;
export const domainName = `${process.env.REACT_APP_DOMAIN}`;
export const domainName_v2 = `${process.env.REACT_APP_DOMAIN_ADDED}`;
/* The public site: contact us, risk solutions, the investment pyramid. */
export const WEBAPPLINK = `${process.env.REACT_APP_WEBAPP_PROTOCOL}://${process.env.REACT_APP_WEBAPP_LINK}`;

/**
 * The app that signs clients in and onboards them — not the public site.
 *
 * Both were WEBAPPLINK, and they are two hosts: on intg the site is
 * staticpages.intg.finadevs.com and the app webapp.intg.finadevs.com, on prod
 * finamaze.com and login.finamaze.com. The site redirects /login to the app
 * but has no /onboarding, so a client who still had onboarding to finish was
 * sent to a 404. Unset (an environment not yet given APP_LINK), it is
 * WEBAPPLINK, as before.
 */
export const APPLINK = process.env.REACT_APP_APP_LINK
  ? `${process.env.REACT_APP_WEBAPP_PROTOCOL}://${process.env.REACT_APP_APP_LINK}`
  : WEBAPPLINK;
export const environment = process.env.REACT_ENV;
export const FACTSHEET = `${process.env.REACT_APP_WEBAPP_PROTOCOL}://${process.env.REACT_APP_API_HOST}`;
